/**
 * Servicio que contiene todas las queries GraphQL y funciones para obtener datos
 * Usa fetch nativo en lugar de Apollo Client
 */

import { contentfulClient } from './contentfulService'
import type {
	AskResponse,
	CareNetworkResponse,
	CareShopResponse,
	ClassesResponse,
	FormChallengeResponse,
	ForTodayResponse,
	HealthAssistantResponse,
	HomeResponse,
	LifeStyleSurveyResponse,
	LoginResponse,
	MetricsResponse,
	MyServicesResponse,
	NotificationResponse,
	NPSResponse,
	ParQResponse,
	PlanResponse,
	ProfileResponse,
	ProgramResponse,
	SadriAnalysisResponse,
	SubscriptionResponse,
	TimeLogoutResponse,
	ToolPaymentControlResponse,
	ToolsResponse
} from '../types/contentful.types'
import type { QRResponse } from '../types/qrCareCenter.types'

// Queries GraphQL
export const ASK_QUERY = `
	query preguntas {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				referenciaPreguntasYClases {
					preguntasHomeBasecareCollection(limit: 20) {
						items {
							titulo
							idTimify
							tipo
							accion
							nombre
							pregunta
							preguntaExtra
							textoInput
							tipoPreguntaExtra
							frecuenciaDeAlimentosCollection(limit: 10) {
								items {
									respuesta
								}
							}
							referenciaOpcionesCollection(limit: 20) {
								items {
									respuesta
									textoInput
									imagenCollection(limit: 2) {
										items {
											url
										}
									}
									imagenActiva {
										url
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

export const HOME_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				vistas {
					contenidoHomeBienvenidaCollection(limit: 30) {
						items {
							idReto
							tituloGeneral
							tituloCard
							titulo2
							descripcion2
							titulo3
							destacado
							descripcion3
							numeroDelReto
							descripcionGeneral
							descripcionCard
							textoBoton
							link
							linkImagen
							imagen {
								url
								fileName
							}
							descripcionDelReto {
								json
							}
							isVisible
							beneficioCollection(limit: 20) {
								items {
									idReto
									tituloGeneral
									descripcionGeneral
									tituloCard
									descripcionCard
									titulo2
									descripcion2
									titulo3
									numeroDelReto
									destacado
									descripcion3
									descripcionDelReto {
										json
									}
									tituloMagenta
									nombreDelReto
									textoBoton
									imagen {
										url
										fileName
									}
									icono {
										fileName
										url
									}
									textoBoton
									link
									textoBotonSecundario
									linkSecundario
									mensaje
									filtros
									premium
									linkImagen
									isVisible
									beneficioCollection(limit: 1) {
										items {
											idReto
											tituloGeneral
											descripcionGeneral
											tituloCard
											descripcionCard
											titulo2
											descripcion2
											titulo3
											numeroDelReto
											destacado
											descripcion3
											descripcionDelReto {
												json
											}
											tituloMagenta
											nombreDelReto
											textoBoton
											linkImagen
											imagen {
												url
												fileName
											}
											icono {
												fileName
												url
											}
											textoBoton
											link
											textoBotonSecundario
											linkSecundario
											mensaje
											filtros
											allowButton
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

export const FOR_TODAY_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				vistas {
					tuRutaDeCuidadoParaHoy {
						tituloGeneral
						beneficioCollection(limit: 5) {
							items {
								idReto
								tituloMagenta
								textoBoton
								link
								tituloGeneral
								descripcionGeneral
								linkImagen
								linkImagenReto
								imagenReto {
									url
								}
								formatoReto
								beneficioCollection(limit: 5) {
									items {
										idReto
										descripcionDelReto {
											json
										}
										linkImagen
										icono {
											url
										}
										textoBoton
										link
										tituloGeneral
									}
								}
							}
						}
						contenidoEnLaManana {
							tituloGeneral
							beneficioCollection(limit: 10) {
								items {
									tituloGeneral
									linkImagen
									linkImagenReto
									imagenReto {
										url
									}
									textoBoton
									link
									tituloGeneral
									tituloCard
									descripcionCard
									formatoReto
									tituloMagenta
									duracionDelReto
									tematica
									icono {
										url
									}
									titulo2
									titulo3
									descripcion2
									subtituloVideo
									tipoDeReto
									intensidadReto
									comunidad
								}
							}
						}
						contenidoEnLaTarde {
							tituloGeneral
							beneficioCollection(limit: 10) {
								items {
									tituloGeneral
									linkImagen
									linkImagenReto
									imagenReto {
										url
									}
									textoBoton
									link
									tituloGeneral
									tituloCard
									descripcionCard
									formatoReto
									tituloMagenta
									duracionDelReto
									tematica
									icono {
										url
									}
									titulo2
									titulo3
									descripcion2
									subtituloVideo
									tipoDeReto
									intensidadReto
									comunidad
								}
							}
						}
						contenidoParaFinalizarElDia {
							tituloGeneral
							beneficioCollection(limit: 10) {
								items {
									tituloGeneral
									linkImagen
									linkImagenReto
									imagenReto {
										url
									}
									textoBoton
									link
									tituloGeneral
									tituloCard
									descripcionCard
									formatoReto
									tituloMagenta
									duracionDelReto
									tematica
									icono {
										url
									}
									titulo2
									titulo3
									descripcion2
									subtituloVideo
									tipoDeReto
									intensidadReto
									comunidad
								}
							}
						}
					}
				}
			}
		}
	}
`

export const PLAN_QUERY = `
	query retos {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				referenciaRetos {
					retosSaludContinuaFrontCollection(limit: 12) {
						items {
							semana
							numeroDelReto
							nombreDelReto
							frecuenciaDelReto
							tipoDeReto
							linkImagen
							descripcionDelReto {
								json
							}
							linkImagenReto
							imagenReto {
								url
								fileName
							}
							icono {
								url
								fileName
							}
							formatoReto
							referenciaSemanasCollection(limit: 12) {
								items {
									numeroDelReto
									nombreDelReto
									duracionDelReto
									descripcionDelReto {
										json
									}
									linkImagen
									linkImagenReto
									imagenReto {
										fileName
										url
									}
									icono {
										fileName
										url
									}
									link
									subtituloVideo
									textoBoton
								}
							}
						}
					}
				}
			}
		}
	}
`

export const PROFILE_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				vistas {
					miPerfil {
						textoBoton
						textoBotonSecundario
						beneficioCollection(limit: 20) {
							items {
								idReto
								tituloGeneral
								descripcionGeneral
								descripcionDelReto {
									json
								}
							}
						}
					}
				}
			}
		}
	}
`

export const TOOLS_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				vistas {
					herramientas {
						idReto
						beneficioCollection(limit: 50) {
							items {
								isVisible
								idReto
								numeroDelReto
								tipoDeReto
								tituloGeneral
								premium
								descripcionDelReto {
									json
								}
								textoBoton
								link
								linkImagenReto
								linkSecundario
								imagenReto {
									url
								}
								icono {
									url
								}
								mensaje
								allowButton
								bgGrayButton
								sendCellphone
								tipoDeServicio
								linkImagen
								filtros
							}
						}
					}
				}
			}
		}
	}
`

export const LOGIN_QUERY = `
	{
  templateContenidoCollection(
    limit: 1
    where: { titulo: "Salud continua > Onboarding" }
  ) {
    items {
      referenciaContenidoCollection(limit: 10) {
        items {
          linkImagen
          imagenPrincipal {
            title
            url
          }
          tituloGeneral
          tituloDescripcion
          placeholder
          tituloBoton
        }
      }
      sectionsCollection(limit: 10) {
        items {
          titulo
          tituloGeneral
          tituloDescripcion
          tituloBoton
          linkImagen
          imagenPrincipal {
            url
          }
          placeholder
          descripcion {
            json
          }
          referenciaContenidoCollection(limit: 10) {
            items {
              tituloGeneral
              descripcion {
                json
              }
              linkImagen
              imagenPrincipal {
                url
              }
              placeholder
              tituloBoton
              identificador1
              identificador2
              tituloDescripcion
              redireccionBoton
            }
          }
          botonCollection(limit: 10) {
            items {
              tituloBoton
            }
          }
          sectionsCollection(limit: 10) {
						items {
							tituloGeneral
							listaImagenesCollection {
								items {
									title
									url
								}
							}
							titulo
							imagenPrincipal {
								url
							}
							tituloDescripcion
							listaJson
						}
					}
        }
      }
    }
  }
}
`

export const NOTIFICATION_QUERY = `
	{
		templateContenidoCollection(limit: 1, where: { titulo: "Salud continua > Notificaciones" }) {
			items {
				referenciaContenidoCollection(limit: 10) {
					items {
						tituloGeneral
						tituloDescripcion
						tituloBoton
						linkImagen
						imagenPrincipal {
							title
							url
						}
						referenciaContenidoCollection(limit: 10) {
							items {
								tituloGeneral
								tituloBoton
								redireccionBoton
								referenciaContenidoCollection(limit: 10) {
									items {
										id
										tituloGeneral
										tituloDescripcion
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

export const NPS_QUERY = `
	{
		templateContenidoCollection(
			limit: 1
			where: { titulo: "Salud continua > Modales de calificación" }
		) {
			items {
				referenciaContenidoCollection {
					items {
						tituloGeneral
						tituloDescripcion
						placeholder
						linkImagen
						imagenPrincipal {
							title
							url
						}
						listaImagenesCollection(limit: 10) {
							items {
								title
								url
							}
						}
						botonCollection(limit: 10) {
							items {
								tituloBoton
								redireccionBoton
							}
						}
					}
				}
			}
		}
	}
`

export const HEALTH_ASSISTANT_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				vistas {
					asistenteDeSalud {
						beneficioCollection(limit: 10) {
							items {
								idReto
								tituloGeneral
								descripcionGeneral
								beneficioCollection(limit: 10) {
									items {
										isVisible
										tituloMagenta
										linkImagenReto
										imagenReto {
											url
										}
										tituloGeneral
										link
										tipoDeReto
										linkImagen
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

export const FORM_CHALLENGE_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				referenciaPreguntasYClases {
					preguntaRetos {
						tituloPrincipal
						subtitulo
						input
						boton
					}
				}
			}
		}
	}
`

export const LIFE_STYLE_SURVEY_QUERY = `
	{
		contenidosRetosCollection(
			where: { titulo: "Salud continua > Accede fácilmente > Cuestionario estilo de vida" }
		) {
			items {
				link
				descripcionCard
				descripcionDelReto {
					json
				}
				titulo
				titulo
				tituloCard
				linkImagen
				linkImagenReto
				imagen {
					title
					url
				}
				imagenReto {
					title
					url
				}
				textoBoton
				isVisible
			}
		}
	}
`

export const MY_SERVICES_QUERY = `
	query contenidosRetosEntryQuery {
		contenidosRetos(id: "6UMxJ6gY4UeLRF9XHTc6vs") {
			tituloGeneral
			isVisible
			descripcionGeneral
			descripcion2
			link
		}
	}
`

export const METRICS_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				listaSdk
				placeholdersBuscador
			}
		}
	}
`

export const PROGRAM_QUERY = `
query VISTA_PROGRAMAS_COLLECTION {
  vistaProgramasCollection {
    items {
      tituloPrincipal
      onboardingUno {
        json
      }
      onboardingDos {
        json
      }
      onboardingTres {
        json
      }
      onboardingCuatro {
        json
      }
      bienvenidoPrograma {
        json
      }
      descripcionLupa {
        json
      }
      tituloInscripcion
      mensajeInscripcion{
        json
      }
      botonUnoInscripcion
      botonDosInscripcion
      explorarPrograma
      busquedaLupa
      inscripcionExitosa{
        json
      }
    }
  }
}
`

export const PARQ_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				parQ {
					parQContent {
						titulo
						tituloBoton
						descripcion
						imagen {
							title
							url
						}
						linkImagen
						modalesCollection {
							items {
								nombreModal
								titulo
								descripcion
								tituloBoton
								linkBoton
								linkImagen
								imagen {
									title
									url
								}
							}
						}
					}
					parQPreguntas {
						tituloBoton
						textoObservacion
						preguntasCollection {
							items {
								descripcion
							}
						}
					}
				}
			}
		}
	}
`

export const TIME_LOGOUT_QUERY = `
	query TIME_LOGOUT {
		contenidosRetos(id: "2eISvQoGPqN1sqOdRQ6oZL") {
			titulo
			duracionDelReto
		}
	}
`

export const SUBSCRIPTION_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				vistas {
					suscripcion {
						mensaje
						beneficioCollection(limit: 10) {
							items {
								idReto
								tituloGeneral
								descripcionDelReto {
									json
								}
								tituloMagenta
								textoBoton
								mensaje
								filtros
								linkImagen
								imagen {
									url
								}
								tituloCard
								beneficioCollection(limit: 10) {
									items {
										tituloGeneral
										filtros
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

export const QR_CARE_CENTER_QUERY = `
	query INGRESOS {
		templateContenidoCollection(limit: 1, where: { titulo: "Salud continua > Ingresos" }) {
			items {
				referenciaContenidoCollection {
					items {
						tituloGeneral
						identificador1
						tituloDescripcion
						identificador2
						linkImagen
						imagenPrincipal {
							title
							url
						}
						botonCollection {
							items {
								tituloBoton
								redireccionBoton
							}
						}
					}
				}
			}
		}
	}
`

export const SADRI_ANALYSIS_QUERY = `
	query contenidosRetosEntryQuery {
		contenidosRetos(id: "2yUwvzX0HwR6BVXRdqvunL") {
			sys {
				id
			}
			beneficioCollection {
				items {
					titulo
					tituloGeneral
					premium
					linkImagen
					icono {
						url
					}
				}
			}
		}
	}
`

export const TOOL_PAYMENT_CONTROL_QUERY = `
	query contenidosRetosEntryQuery {
		contenidosRetos(id: "2yUwvzX0HwR6BVXRdqvunL") {
			sys {
				id
			}
			isVisible
			tituloGeneral
			titulo2
			titulo3
			beneficioCollection {
				items {
					idReto
					numeroDelReto
					tipoDeReto
					link
					titulo
					titulo2
					titulo3
					tituloGeneral
					premium
					isVisible
					descripcion3
					linkImagen
					icono {
						url
					}
				}
			}
		}
	}
`

export const CLASSES_QUERY = `
	query clases {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				copyClases
				lugarClases
				referenciaPreguntasYClases {
					modalSaludContinuaCollection(limit: 10) {
						items {
							tituloModal
							descripcionModal
							copyBoton
							imagenCollection {
								items {
									url
									fileName
								}
							}
						}
					}
				}
			}
		}
	}
`

export const CARESHOP_QUERY = `
	query QUERY_TIENDA_DEL_CUIDADO_INTERNA {
		contenidosRetos(id: "2mUmSXtvfWE5YXpWVskh8i") {
			tituloGeneral
			titulo2
			titulo3
			beneficioCollection {
				items {
					titulo
					tituloGeneral
					titulo2
					numeroDelReto
					premium
					isVisible
					link
					linkSecundario
					linkImagen
					imagen {
						url
					}
					idReto
				}
			}
		}
	}
`

export const CARENETWORK_QUERY = `
	query CONTENIDO_CARE_NETWORK {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				vistas {
					redDeCuidado {
						idReto
						tituloGeneral
						descripcionGeneral
						titulo2
						descripcion2
						descripcion3
						linkImagen
						imagen {
							url
						}
						textoBoton
						link
						beneficioCollection(limit: 10) {
							items {
								idReto
								tituloGeneral
								descripcionDelReto {
									json
								}
								tituloCard
								linkImagen
								imagen {
									url
								}
								beneficioCollection(limit: 10) {
									items {
										tituloGeneral
										idReto
										textoBoton
										linkSecundario
										formatoReto
										duracionDelReto
										descripcionGeneral
										premium
										destacado
										tituloCard
										linkImagen
										imagen {
											url
										}
										beneficioCollection(limit: 10) {
											items {
												idReto
												textoBoton
												linkSecundario
												formatoReto
												duracionDelReto
												tituloGeneral
												descripcionGeneral
												descripcionDelReto {
													json
												}
												imagen {
													url
												}
												premium
												destacado
												titulo2
												filtros
												linkImagen
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

// API para obtener datos
export const queriesApi = {
	async getAsk(): Promise<AskResponse> {
		try {
			return await contentfulClient.request({ query: ASK_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Ask:', error)
			throw error
		}
	},

	async getHome(): Promise<HomeResponse> {
		try {
			return await contentfulClient.request({ query: HOME_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Home:', error)
			throw error
		}
	},

	async getForToday(): Promise<ForTodayResponse> {
		try {
			return await contentfulClient.request({ query: FOR_TODAY_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de For Today:', error)
			throw error
		}
	},

	async getPlan(): Promise<PlanResponse> {
		try {
			return await contentfulClient.request({ query: PLAN_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Plan:', error)
			throw error
		}
	},

	async getProfile(): Promise<ProfileResponse> {
		try {
			return await contentfulClient.request({ query: PROFILE_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Profile:', error)
			throw error
		}
	},

	async getTools(): Promise<ToolsResponse> {
		try {
			return await contentfulClient.request({ query: TOOLS_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Tools:', error)
			throw error
		}
	},

	async getLogin(): Promise<LoginResponse> {
		try {
			return await contentfulClient.request({ query: LOGIN_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Login:', error)
			throw error
		}
	},

	async getNotification(): Promise<NotificationResponse> {
		try {
			return await contentfulClient.request({ query: NOTIFICATION_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Notification:', error)
			throw error
		}
	},

	async getNPS(): Promise<NPSResponse> {
		try {
			return await contentfulClient.request({ query: NPS_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de NPS:', error)
			throw error
		}
	},

	async getHealthAssistant(): Promise<HealthAssistantResponse> {
		try {
			return await contentfulClient.request({ query: HEALTH_ASSISTANT_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Health Assistant:', error)
			throw error
		}
	},

	async getFormChallenge(): Promise<FormChallengeResponse> {
		try {
			return await contentfulClient.request({ query: FORM_CHALLENGE_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Form Challenge:', error)
			throw error
		}
	},

	async getLifeStyleSurvey(): Promise<LifeStyleSurveyResponse> {
		try {
			return await contentfulClient.request({ query: LIFE_STYLE_SURVEY_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Life Style Survey:', error)
			throw error
		}
	},

	async getMyServices(): Promise<MyServicesResponse> {
		try {
			return await contentfulClient.request({ query: MY_SERVICES_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de My Services:', error)
			throw error
		}
	},

	async getMetrics(): Promise<MetricsResponse> {
		try {
			return await contentfulClient.request({ query: METRICS_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Metrics:', error)
			throw error
		}
	},

	async getProgram(): Promise<ProgramResponse> {
		try {
			return await contentfulClient.request({ query: PROGRAM_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Program:', error)
			throw error
		}
	},

	async getParQ(): Promise<ParQResponse> {
		try {
			return await contentfulClient.request({ query: PARQ_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de ParQ:', error)
			throw error
		}
	},

	async getTimeLogout(): Promise<TimeLogoutResponse> {
		try {
			return await contentfulClient.request({ query: TIME_LOGOUT_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de TimeLogout:', error)
			throw error
		}
	},

	async getSubscription(): Promise<SubscriptionResponse> {
		try {
			return await contentfulClient.request({ query: SUBSCRIPTION_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Subscription:', error)
			throw error
		}
	},

	async getQRCareCenter(): Promise<QRResponse> {
		try {
			return await contentfulClient.request({ query: QR_CARE_CENTER_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de QR Care Center:', error)
			throw error
		}
	},

	async getSadriAnalysis(): Promise<SadriAnalysisResponse> {
		try {
			return await contentfulClient.request({ query: SADRI_ANALYSIS_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Sadri Analysis:', error)
			throw error
		}
	},

	async getClasses(): Promise<ClassesResponse> {
		try {
			return await contentfulClient.request({ query: CLASSES_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de Classes:', error)
			throw error
		}
	},

	async getCareShop(): Promise<CareShopResponse> {
		try {
			return await contentfulClient.request({ query: CARESHOP_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de CareShop:', error)
			throw error
		}
	},

	async getCareNetwork(): Promise<CareNetworkResponse> {
		try {
			return await contentfulClient.request({ query: CARENETWORK_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de CareNetwork:', error)
			throw error
		}
	},

	async getToolPaymentControl(): Promise<ToolPaymentControlResponse> {
		try {
			return await contentfulClient.request({ query: TOOL_PAYMENT_CONTROL_QUERY })
		} catch (error) {
			console.error('Error al obtener datos de ToolPaymentControl:', error)
			throw error
		}
	}
}

export default queriesApi
